// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-controller {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(260px, 31vw, 430px);
  height: clamp(320px, 39vw, 500px);
  animation: avatar-controller-float 4.4s ease-in-out infinite;
  contain: layout paint style;
  will-change: transform;
}

.avatar-controller--small {
  width: 100%;
  height: 100%;
  min-width: 140px;
  min-height: 160px;
}

.avatar-controller--medium {
  width: clamp(220px, 26vw, 360px);
  height: clamp(280px, 34vw, 430px);
}

.avatar-controller--large {
  width: clamp(260px, 31vw, 430px);
  height: clamp(320px, 39vw, 500px);
}

.avatar-controller__halo {
  position: absolute;
  width: 94%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%), radial-gradient(circle, rgba(250, 204, 21, 0.12), transparent 72%);
  filter: blur(6px);
  animation: avatar-controller-breathe 2.8s ease-in-out infinite;
  transition: background 280ms ease, opacity 280ms ease;
}

.avatar-controller__focus-ring {
  position: absolute;
  width: 82%;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid rgba(250, 204, 21, 0.22);
  box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.12);
  animation: avatar-controller-orbit 18s linear infinite;
  transition: border-color 280ms ease, box-shadow 280ms ease;
}

.avatar-controller__sprite-wrap {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 420px);
  height: min(100%, 420px);
  filter: drop-shadow(0 28px 44px rgba(0, 0, 0, 0.34));
  transform-style: preserve-3d;
  will-change: transform;
}

.avatar-controller__sprite {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.avatar-controller__shadow {
  position: absolute;
  z-index: 1;
  bottom: 13%;
  width: 52%;
  height: 34px;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.36), transparent 70%);
  filter: blur(8px);
}

.avatar-controller--tone-success .avatar-controller__halo {
  background: radial-gradient(circle, rgba(52, 211, 153, 0.22), transparent 58%), radial-gradient(circle, rgba(250, 204, 21, 0.13), transparent 72%);
}

.avatar-controller--tone-listening .avatar-controller__halo {
  background: radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%), radial-gradient(circle, rgba(59, 130, 246, 0.12), transparent 72%);
}

.avatar-controller--tone-thinking .avatar-controller__halo {
  background: radial-gradient(circle, rgba(124, 58, 237, 0.2), transparent 62%);
}

.avatar-controller--tone-warning .avatar-controller__halo {
  background: radial-gradient(circle, rgba(245, 158, 11, 0.24), transparent 62%);
}

.avatar-controller--tone-speaking .avatar-controller__halo {
  background: radial-gradient(circle, rgba(250, 204, 21, 0.2), transparent 58%), radial-gradient(circle, rgba(45, 212, 191, 0.14), transparent 72%);
}

.avatar-controller--tone-listening .avatar-controller__focus-ring {
  border-color: rgba(45, 212, 191, 0.34);
  box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.14);
}

.avatar-controller--tone-warning .avatar-controller__focus-ring {
  border-color: rgba(245, 158, 11, 0.34);
  box-shadow: inset 0 0 44px rgba(245, 158, 11, 0.14);
}

@media (max-width: 768px) {
  .avatar-controller--large {
    width: min(72vw, 300px);
    height: min(92vw, 390px);
  }
}
@keyframes avatar-controller-float {
  0%, 100% {
    transform: translate3d(0, 0, 0) rotate(-0.4deg);
  }
  50% {
    transform: translate3d(0, -10px, 0) rotate(0.6deg);
  }
}
@keyframes avatar-controller-breathe {
  0%, 100% {
    transform: scale(0.96);
    opacity: 0.72;
  }
  50% {
    transform: scale(1.06);
    opacity: 1;
  }
}
@keyframes avatar-controller-orbit {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/avatar/avatarAnimations.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EACA,4DAAA;EACA,2BAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gCAAA;EACA,iCAAA;AACF;;AAEA;EACE,gCAAA;EACA,iCAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,iJACE;EAEF,iBAAA;EACA,8DAAA;EACA,qDAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,mDAAA;EACA,sDAAA;EACA,0DAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oDAAA;EACA,4BAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oFAAA;EACA,iBAAA;AADF;;AAIA;EACE,kJACE;AAFJ;;AAMA;EACE,iJACE;AAJJ;;AAQA;EACE,6EAAA;AALF;;AAQA;EACE,8EAAA;AALF;;AAQA;EACE,iJACE;AANJ;;AAUA;EACE,sCAAA;EACA,mDAAA;AAPF;;AAUA;EACE,sCAAA;EACA,mDAAA;AAPF;;AAUA;EACE;IACE,uBAAA;IACA,wBAAA;EAPF;AACF;AAUA;EACE;IACE,+CAAA;EARF;EAWA;IACE,kDAAA;EATF;AACF;AAYA;EACE;IACE,sBAAA;IACA,aAAA;EAVF;EAaA;IACE,sBAAA;IACA,UAAA;EAXF;AACF;AAcA;EACE;IACE,uBAAA;EAZF;EAeA;IACE,yBAAA;EAbF;AACF","sourcesContent":[".avatar-controller {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(260px, 31vw, 430px);\n  height: clamp(320px, 39vw, 500px);\n  animation: avatar-controller-float 4.4s ease-in-out infinite;\n  contain: layout paint style;\n  will-change: transform;\n}\n\n.avatar-controller--small {\n  width: 100%;\n  height: 100%;\n  min-width: 140px;\n  min-height: 160px;\n}\n\n.avatar-controller--medium {\n  width: clamp(220px, 26vw, 360px);\n  height: clamp(280px, 34vw, 430px);\n}\n\n.avatar-controller--large {\n  width: clamp(260px, 31vw, 430px);\n  height: clamp(320px, 39vw, 500px);\n}\n\n.avatar-controller__halo {\n  position: absolute;\n  width: 94%;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background:\n    radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%),\n    radial-gradient(circle, rgba(250, 204, 21, 0.12), transparent 72%);\n  filter: blur(6px);\n  animation: avatar-controller-breathe 2.8s ease-in-out infinite;\n  transition: background 280ms ease, opacity 280ms ease;\n}\n\n.avatar-controller__focus-ring {\n  position: absolute;\n  width: 82%;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 1px solid rgba(250, 204, 21, 0.22);\n  box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.12);\n  animation: avatar-controller-orbit 18s linear infinite;\n  transition: border-color 280ms ease, box-shadow 280ms ease;\n}\n\n.avatar-controller__sprite-wrap {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: min(100%, 420px);\n  height: min(100%, 420px);\n  filter: drop-shadow(0 28px 44px rgba(0, 0, 0, 0.34));\n  transform-style: preserve-3d;\n  will-change: transform;\n}\n\n.avatar-controller__sprite {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  user-select: none;\n  pointer-events: none;\n}\n\n.avatar-controller__shadow {\n  position: absolute;\n  z-index: 1;\n  bottom: 13%;\n  width: 52%;\n  height: 34px;\n  border-radius: 50%;\n  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.36), transparent 70%);\n  filter: blur(8px);\n}\n\n.avatar-controller--tone-success .avatar-controller__halo {\n  background:\n    radial-gradient(circle, rgba(52, 211, 153, 0.22), transparent 58%),\n    radial-gradient(circle, rgba(250, 204, 21, 0.13), transparent 72%);\n}\n\n.avatar-controller--tone-listening .avatar-controller__halo {\n  background:\n    radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%),\n    radial-gradient(circle, rgba(59, 130, 246, 0.12), transparent 72%);\n}\n\n.avatar-controller--tone-thinking .avatar-controller__halo {\n  background: radial-gradient(circle, rgba(124, 58, 237, 0.2), transparent 62%);\n}\n\n.avatar-controller--tone-warning .avatar-controller__halo {\n  background: radial-gradient(circle, rgba(245, 158, 11, 0.24), transparent 62%);\n}\n\n.avatar-controller--tone-speaking .avatar-controller__halo {\n  background:\n    radial-gradient(circle, rgba(250, 204, 21, 0.2), transparent 58%),\n    radial-gradient(circle, rgba(45, 212, 191, 0.14), transparent 72%);\n}\n\n.avatar-controller--tone-listening .avatar-controller__focus-ring {\n  border-color: rgba(45, 212, 191, 0.34);\n  box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.14);\n}\n\n.avatar-controller--tone-warning .avatar-controller__focus-ring {\n  border-color: rgba(245, 158, 11, 0.34);\n  box-shadow: inset 0 0 44px rgba(245, 158, 11, 0.14);\n}\n\n@media (max-width: 768px) {\n  .avatar-controller--large {\n    width: min(72vw, 300px);\n    height: min(92vw, 390px);\n  }\n}\n\n@keyframes avatar-controller-float {\n  0%, 100% {\n    transform: translate3d(0, 0, 0) rotate(-0.4deg);\n  }\n\n  50% {\n    transform: translate3d(0, -10px, 0) rotate(0.6deg);\n  }\n}\n\n@keyframes avatar-controller-breathe {\n  0%, 100% {\n    transform: scale(0.96);\n    opacity: 0.72;\n  }\n\n  50% {\n    transform: scale(1.06);\n    opacity: 1;\n  }\n}\n\n@keyframes avatar-controller-orbit {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
